import { render, staticRenderFns } from "./anz-main-page-slider.vue?vue&type=template&id=129f8b17&scoped=true"
import script from "./anz-main-page-slider.vue?vue&type=script&lang=js"
export * from "./anz-main-page-slider.vue?vue&type=script&lang=js"
import style0 from "./anz-main-page-slider.vue?vue&type=style&index=0&id=129f8b17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129f8b17",
  null
  
)

export default component.exports